import { Suspense, useState } from "react";
import Sidebar from "./Sidebar";
import TopHeader from "../TopHeader";
import { Outlet, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./transitions.css"
const Layout = () => {
  const [toggle, setToggle] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setToggle(!toggle);
  };

  const loading = (
    <div className="loading">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
  return (
    <>
      <Suspense fallback={loading}>
        <div className="main-wrap">
          {toggle && (
            <div
              className="sidebar-overlay d-xl-none"
              onClick={() => setToggle(false)}
            ></div>
          )}
          <div className={toggle ? "left-side show-mobile" : "left-side"}>
            <Sidebar
              isActive={isActive}
              setIsActive={setIsActive}
              toggle={toggle}
              setToggle={setToggle}
            />
          </div>
          <div className="right-side-cmn" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <TopHeader toggleSidebar={toggleSidebar} />
            <div style={{ flex: 1 }}>
              <TransitionGroup>
                <CSSTransition
                  key={location.pathname}
                  timeout={300}
                  classNames="page"
                >
                  <div className="page-wrapper">
                    <Outlet />
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
            <div className="made-with">
              <div className="Codobux">
                <p className="ms-3">
                  © {new Date().getFullYear()}, Made with ❤️ by{" "}
                  <span>Codobux</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </>
  );
};

export default Layout;
